class SchedulesOnProfileActionsModalController {
    constructor() {
        // this.actionType = this.resolve.actionType;
        // this.actionLabel = this.resolve.actionLabel;
        // this.jobMatchId = this.resolve.jobMatchId;
        // this.candidateId = this.resolve.candidateId;
        // this.meetingScheduleId = this.resolve.meetingScheduleId;
        // this.externalMeetingCallId = this.resolve.externalMeetingCallId;
    }
    $onInit() {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.jobMatchId = this.resolve.jobMatchId;
        this.candidateId = this.resolve.candidateId;
        this.meetingScheduleId = this.resolve.meetingScheduleId;
        this.externalMeetingCallId = this.resolve.externalMeetingCallId;
        this.sourceScreen = this.resolve.sourceScreen;
        this.formalizeActivityPayload = this.resolve.formalizeActivityPayload;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    moveCandidateCallback() {
        this.callbackObject.callbackType = 'moveCandidate';
        this.closeModal();
    }
}
// import * as TEMPLATE from './schedules-on-profile-actions-modal.html;
import * as TEMPLATE from 'raw-loader!./schedules-on-profile-actions-modal.html';
export const SchedulesOnProfileActionsModalComponent = {
    selector: 'schedulesOnProfileActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: SchedulesOnProfileActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/schedulesOnProfile/schedulesOnProfileActionsModal/schedules-on-profile-actions-modal.html'
    }
};
//# sourceMappingURL=schedules-on-profile-actions-modal.component.js.map